export default __webpack_public_path__ + "93cc41475fe476218e715e52fcc3be07.png";